export const LANGUAGES = [
  { label: 'English', languageCode: 'en' },
  { label: 'German', languageCode: 'de' },
  { label: 'Spanish', languageCode: 'es' },
  { label: 'French', languageCode: 'fr' },
  { label: 'Portuguese', languageCode: 'pt' },
  { label: 'Russian', languageCode: 'ru' }
]

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'e54_auth_token'
export const LANGUAGE = 'e54_language'
export const OPERATOR_ID = 'e54_operator_id'
export const ROLE = 'e54_operator_role'

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
export const ROUTE_PATHS = {
  // ----single routes------------
  home: '/',
  crashGame: '/crash-game',
  kenoGame: '/keno-game',
  hiloGame: '/hilo-game',
  blackjackGame: '/blackjack-game',
  rouletteGame: '/roulette-game',
  flipCoinGame: '/flip-coin-game',
  sessionOut: '/session-expire'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER = {
  BUTTON: 'button',
  CONTENT: 'content',
  TABLE_CELL: 'tableCell'
}

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Game Ids
========================================================================== */
export const DEFAULT_GAME_ID = {
  CRASH: 1,
  HILO: 2,
  KENO: 3,
  BLACKJACK: 4,
  ROULETTE: 5,
  FLIP_COIN: 6
}

/* ==========================================================================
  Game Result
========================================================================== */
export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
}

/* ==========================================================================
  Flip Coin Game Constants
========================================================================== */
export const MIN_COIN_COUNT = 1
export const MAX_COIN_COUNT = 10

export const S3_BUCKET_ENDPOINT_FAST_GAMES = 'https://fastgames-dev-storage.s3.amazonaws.com'

export const DEFAULT_PAGE_CALLS = 10

/* ==========================================================================
  Currency Symbols
========================================================================== */
export const CURRENCY_SYMBOL = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  INR: '₹',
  AED: 'إ.د',
  VND: '₫',
  IDR: 'Rp',
  PHP: '₱',
  JPY: '¥',
  KRW: '₩',
  RUB: '₽',
  MYR: 'RM',
  THB: '฿',
  BRL: 'R$',
  CNY: '¥',
  CAD: '$',
  MXN: '$',
  NGN: '₦',
  TRY: '₺',
  NZD: '$',
  AUD: '$',
  ARS: '$',
  ILS: '₪',
  UAH: '₴',
  PLN: 'zł'
}

export const CURRENCIES = {
  EUR: { isFiat: true, precision: 2, symbol: '€', label: 'Euro', value: 'EUR', fileName: 'euro.svg' },
  USD: { isFiat: true, precision: 2, symbol: '$', label: 'US Dollar', value: 'USD', fileName: 'dollar-symbol.svg' },
  GBP: { isFiat: true, precision: 2, symbol: '£', label: 'British Pound', value: 'GBP', fileName: 'british-pound.svg' },
  CAD: { isFiat: true, precision: 2, symbol: 'C$', label: 'Canadian Dollar', value: 'CAD', fileName: 'canadian-dollar.svg' },
  AUD: { isFiat: true, precision: 2, symbol: 'A$', label: 'Australian Dollar', value: 'AUD', fileName: 'australian-dollar.svg' },
  JPY: { isFiat: true, precision: 2, symbol: '¥', label: 'Japanese Yen', value: 'JPY', fileName: 'japanese-yen.svg' },
  CHF: { isFiat: true, precision: 2, symbol: 'CHF', label: 'Swiss Franc', value: 'CHF', fileName: 'swiss-franc.svg' },
  SEK: { isFiat: true, precision: 2, symbol: 'kr', label: 'Swedish Krona', value: 'SEK', fileName: 'krona.svg' },
  NOK: { isFiat: true, precision: 2, symbol: 'kr', label: 'Norwegian Krone', value: 'NOK', fileName: 'krone.svg' },
  NZD: { isFiat: true, precision: 2, symbol: 'NZ$', label: 'New Zealand Dollar', value: 'NZD', fileName: 'new-zealand-dollar.svg' },
  SGD: { isFiat: true, precision: 2, symbol: 'S$', label: 'Singapore Dollar', value: 'SGD', fileName: 'ingapore-dollar.svg' },
  ZAR: { isFiat: true, precision: 2, symbol: 'R', label: 'South African Rand', value: 'ZAR', fileName: 'south-african-rand.svg' },
  MXN: { isFiat: true, precision: 2, symbol: 'MX$', label: 'Mexican Peso', value: 'MXN', fileName: 'peso.svg' },
  RUB: { isFiat: true, precision: 2, symbol: '₽', label: 'Russian Ruble', value: 'RUB', fileName: 'ruble.svg' },
  INR: { isFiat: true, precision: 2, symbol: '₹', label: 'Indian Rupee', value: 'INR', fileName: 'rupee-sign.svg' },
  BRL: { isFiat: true, precision: 2, symbol: 'R$', label: 'Brazilian Real', value: 'BRL', fileName: 'brazilian-real.svg' },
  DKK: { isFiat: true, precision: 2, symbol: 'kr', label: 'Danish Krone', value: 'DKK', fileName: 'danish-krone.svg' },
  PHP: { isFiat: true, precision: 2, symbol: '₱', label: 'Philippine Peso', value: 'PHP', fileName: 'philippine-peso.svg' },
  THB: { isFiat: true, precision: 2, symbol: '฿', label: 'Thai Baht', value: 'THB', fileName: 'aht.svg' },
  HKD: { isFiat: true, precision: 2, symbol: 'HK$', label: 'Hong Kong Dollar', value: 'HKD', fileName: 'hong-kong-dollar.svg' },
  TRY: { isFiat: true, precision: 2, symbol: '₺', label: 'Turkish Lira', value: 'TRY', fileName: 'lira.svg' },
  CZK: { isFiat: true, precision: 2, symbol: 'Kč', label: 'Czech Koruna', value: 'CZK', fileName: 'czech-koruna.svg' },
  CLP: { isFiat: true, precision: 2, symbol: 'CLP$', label: 'Chilean Peso', value: 'CLP', fileName: 'chilean.svg' },
  PLN: { isFiat: true, precision: 2, symbol: 'zł', label: 'Polish Zloty', value: 'PLN', fileName: 'currency.svg' },
  MYR: { isFiat: true, precision: 2, symbol: 'RM', label: 'Malaysian Ringgit', value: 'MYR', fileName: 'rm.svg' },
  RON: { isFiat: true, precision: 2, symbol: 'lei', label: 'Romanian Leu', value: 'RON', fileName: 'leu.svg' },
  BTC: { isFiat: false, precision: 8, symbol: '₿', label: 'Bitcoin', value: 'BTC', fileName: 'bitcoin-btc.svg' },
  ETH: { isFiat: false, precision: 8, symbol: 'Ξ', label: 'Ethereum', value: 'ETH', fileName: 'etherum-eth.svg' },
  BCH: { isFiat: false, precision: 8, symbol: 'BCH', label: 'Bitcoin Cash', value: 'BCH', fileName: 'bitcoin-bch.svg' },
  LTC: { isFiat: false, precision: 8, symbol: 'Ł', label: 'Litecoin', value: 'LTC', fileName: 'litecoin-ltc.svg' },
  XRP: { isFiat: false, precision: 8, symbol: 'XRP', label: 'Ripple', value: 'XRP', fileName: 'riple-xrp.svg' },
  ADA: { isFiat: false, precision: 8, symbol: 'ADA', label: 'Cardano', value: 'ADA', fileName: 'cardano-ada.svg' },
  DOGE: { isFiat: false, precision: 8, symbol: 'Ð', label: 'Dogecoin', value: 'DOGE', fileName: 'dogecoin-doge.svg' },
  USDT: { isFiat: false, precision: 8, symbol: 'USDT', label: 'Tether', value: 'USDT', fileName: 'thether-USDT.svg' },
  BNB: { isFiat: false, precision: 8, symbol: 'BNB', label: 'Binance Coin', value: 'BNB', fileName: 'binance-BNB.svg' },
  SOL: { isFiat: false, precision: 8, symbol: 'SOL', label: 'Solana', value: 'SOL', fileName: 'solana-sol.svg' },
  DOT: { isFiat: false, precision: 8, symbol: 'DOT', label: 'Polkadot', value: 'DOT', fileName: 'polkadot-dot.svg' },
  LINK: { isFiat: false, precision: 8, symbol: 'LINK', label: 'Chainlink', value: 'LINK', fileName: 'chainlink-link.svg' },
  TRX: { isFiat: false, precision: 8, symbol: 'TRX', label: 'Tron', value: 'TRX', fileName: 'tron-trx.svg' },
  XLM: { isFiat: false, precision: 8, symbol: 'XLM', label: 'Stellar', value: 'XLM', fileName: 'stellar-xlm.svg' },
  XMR: { isFiat: false, precision: 8, symbol: 'XMR', label: 'Monero', value: 'XMR', fileName: 'monero-xmr.svg' },
  DASH: { isFiat: false, precision: 8, symbol: 'DASH', label: 'Dash', value: 'DASH', fileName: 'dash-dash.svg' },
  VET: { isFiat: false, precision: 8, symbol: 'VET', label: 'VeChain', value: 'VET', fileName: 'vechain-vet.svg' },
  ETC: { isFiat: false, precision: 8, symbol: 'ETC', label: 'Ethereum Classic', value: 'ETC', fileName: 'etherum-classic-etc.svg' },
  NEO: { isFiat: false, precision: 8, symbol: 'NEO', label: 'Neo', value: 'NEO', fileName: 'neo-neo.svg' },
  ZEC: { isFiat: false, precision: 8, symbol: 'ZEC', label: 'Zcash', value: 'ZEC', fileName: 'zcash-zec.svg' },
  ATOM: { isFiat: false, precision: 8, symbol: 'ATOM', label: 'Cosmos', value: 'ATOM', fileName: 'cosmos-atom.svg' },
  ALGO: { isFiat: false, precision: 8, symbol: 'ALGO', label: 'Algorand', value: 'ALGO', fileName: 'algorand-algo.svg' },
  XTZ: { isFiat: false, precision: 8, symbol: 'XTZ', label: 'Tezos', value: 'XTZ', fileName: 'tezos-xtz.svg' },
  FTM: { isFiat: false, precision: 8, symbol: 'FTM', label: 'Fantom', value: 'FTM', fileName: 'fantom-ftm.svg' },
  EGLD: { isFiat: false, precision: 8, symbol: 'EGLD', label: 'Elrond', value: 'EGLD', fileName: 'elrond-egld.svg' }
}
/* ==========================================================================
  Other constants
========================================================================== */
export const MAX_INCREASED_BY_PERCENTAGE = {
  CRASH_AUTO_BET: 10000
}
